<template>
  <div>

    <form enctype="multipart/form-data" class="new-donation-modal" id="createDonation" v-if="isInitResultState"
          @submit.prevent="submitForm"
    >
      <AtButton
          class="new-donation-modal__all"
          type="primary"
          icon="icon-arrow-left"
          @click="goBack"
          ref="backButton"
      >
        {{ $t('order.return') }}
      </AtButton>
      <div class="new-donation-modal__title-container">
        <h2 class="new-donation-modal__title" v-if="!previewData">{{ $t('create-donation.step-1.title') }}</h2>
        <h2 class="new-donation-modal__title" v-else>{{ $t('create-donation.step-2.title') }}</h2>
      </div>
      <div class="new-donation-modal__subtitle-container">
        <h3 class="new-donation-modal__subtitle" v-if="!previewData">{{ $t('create-donation.step-1.description') }}</h3>
        <h3 class="new-donation-modal__subtitle" v-else>{{ $t('create-donation.step-2.description') }}</h3>
      </div>
      <donation-pre-checkout v-if="!previewData" :theme="theme">
        <template #user-info>
          <div class="new-donation-modal__donation-info">
            <div class="new-donation-modal__user-info">

              <div class="new-donation-modal__avatar" @click="openImageModal">
                <img class="new-donation-modal__avatar-img" :src="previewURl" v-if="previewURl"/>
                <svg class="new-donation-modal__avatar_placeholder" v-if="!previewURl" width="106" height="106"
                     viewBox="0 0 106 106" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="53" cy="53" r="50.5" fill="#E7F0FF" stroke="white" stroke-width="5"/>
                  <path
                      d="M52.9998 51.1667C48.9497 51.1667 45.6665 47.8834 45.6665 43.8333C45.6665 39.7832 48.9497 36.5 52.9998 36.5C57.0499 36.5 60.3332 39.7832 60.3332 43.8333C60.3332 47.8834 57.0499 51.1667 52.9998 51.1667Z"
                      stroke="#0059F7" stroke-width="2" stroke-linecap="round"/>
                  <path
                      d="M38.3333 69.5V67.6667C38.3333 61.5915 43.2581 56.6667 49.3333 56.6667H56.6666C62.7417 56.6667 67.6666 61.5915 67.6666 67.6667V69.5"
                      stroke="#0059F7" stroke-width="2" stroke-linecap="round"/>
                </svg>


                <div class="new-donation-modal__avatar-hover">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.75 6L9 2.25L5.25 6" stroke="white" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M9 2.25V11.25" stroke="white" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                  <p class="new-donation-modal__avatar-text">{{ $t('create-donation.upload-photo') }}</p>
                </div>

              </div>
              <div class="new-donation-modal__text-container">


                <div class="new-donation-modal__textarea-container">
                  <AtInput
                      class="new-donation-modal__user-info-input new-donation-modal__user-info-input_alias"
                      v-model="alias"
                      :maxlength="40"
                      :placeholder="$t('create-donation.inputs.labels.alias')"
                      size="normal"
                  />
                </div>
                <div class="new-donation-modal__textarea-container">
                  <span class="new-donation-modal__textarea-prepend">{{ location }}</span>
                  <AtTextarea
                      class="new-donation-modal__user-info-input"
                      v-model="url"
                      :maxlength="30"
                      size="normal"
                      resize="none"
                      autosize
                      @input="wrapCheckURL"
                  >

                  </AtTextarea>
                  <blue-loader class="loader" :width="'18'" :height="'18'" :color="'#ffffff'" v-if="isLoading"/>
                  <icon-checkmark-validation class="loader" v-if="!isLoading && !isDisabled && isChanged"/>
                  <icon-error-validation class="loader" v-if="!isLoading && isDisabled && isChanged"/>
                </div>


              </div>

              <div class="new-donation-modal__color-container">
                <div class="new-donation-modal__color-placeholder ">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.83903 5.85799C6.77903 1.94199 12.869 0.802986 17.203 3.49799C21.483 6.15799 23.057 11.275 21.303 16.075C19.648 20.608 15.287 22.403 12.144 20.123C10.967 19.269 10.51 18.198 10.29 16.459L10.184 15.472L10.139 15.074C10.016 14.14 9.82803 13.722 9.43403 13.502C8.89903 13.204 8.54203 13.197 7.83903 13.469L7.48803 13.615L7.30903 13.693C6.29503 14.133 5.62103 14.288 4.76803 14.109L4.56803 14.062L4.40403 14.015C1.61503 13.151 1.20203 9.36799 3.83903 5.85799ZM4.82303 12.574L4.94603 12.611L5.08003 12.641C5.51903 12.728 5.89403 12.656 6.51703 12.399L7.11903 12.142C8.32103 11.649 9.10403 11.602 10.165 12.192C11.082 12.704 11.44 13.49 11.622 14.852L11.675 15.311L11.73 15.843L11.777 16.265C11.949 17.626 12.262 18.355 13.025 18.909C15.3 20.559 18.559 19.218 19.895 15.56C21.411 11.408 20.069 7.04599 16.411 4.77099C12.736 2.48699 7.51203 3.46499 5.03803 6.75799C2.96303 9.52099 3.21803 12.038 4.82303 12.574ZM16.048 10.58C16.0008 10.42 15.986 10.2522 16.0047 10.0864C16.0233 9.92065 16.0749 9.76028 16.1565 9.61477C16.238 9.46926 16.3479 9.34154 16.4796 9.23915C16.6113 9.13676 16.7621 9.06176 16.9232 9.01857C17.0844 8.97539 17.2525 8.96489 17.4178 8.9877C17.583 9.01051 17.742 9.06616 17.8854 9.15137C18.0288 9.23659 18.1537 9.34965 18.2527 9.48388C18.3518 9.61812 18.4229 9.77082 18.462 9.93299C18.5384 10.25 18.488 10.5842 18.3214 10.8645C18.1549 11.1448 17.8854 11.3489 17.5704 11.4333C17.2555 11.5178 16.9201 11.4758 16.6357 11.3163C16.3512 11.1569 16.1404 10.8927 16.048 10.58ZM16.542 14.068C16.4562 13.7477 16.5012 13.4065 16.6669 13.1194C16.8327 12.8323 17.1058 12.6228 17.426 12.537C17.7463 12.4512 18.0875 12.4961 18.3746 12.6619C18.6617 12.8277 18.8712 13.1007 18.957 13.421C18.9995 13.5796 19.0103 13.7449 18.9889 13.9077C18.9675 14.0705 18.9142 14.2274 18.8321 14.3696C18.75 14.5117 18.6407 14.6363 18.5105 14.7363C18.3802 14.8362 18.2316 14.9095 18.073 14.952C17.9145 14.9945 17.7491 15.0053 17.5863 14.9839C17.4236 14.9624 17.2666 14.9092 17.1244 14.8271C16.9823 14.745 16.8577 14.6357 16.7577 14.5055C16.6578 14.3752 16.5845 14.2266 16.542 14.068ZM14.07 7.57699C13.9842 7.25674 14.0292 6.91552 14.1949 6.6284C14.3607 6.34129 14.6338 6.13178 14.954 6.04599C15.2743 5.96019 15.6155 6.00512 15.9026 6.17091C16.1897 6.33669 16.3992 6.60974 16.485 6.92999C16.5275 7.08856 16.5383 7.25394 16.5169 7.4167C16.4955 7.57946 16.4422 7.7364 16.3601 7.87857C16.278 8.02074 16.1687 8.14534 16.0385 8.24527C15.9082 8.3452 15.7596 8.4185 15.601 8.46099C15.2808 8.54678 14.9396 8.50185 14.6524 8.33607C14.5103 8.25398 14.3857 8.14469 14.2857 8.01445C14.1858 7.88421 14.1125 7.73556 14.07 7.57699ZM14.042 16.575C13.9948 16.415 13.98 16.2472 13.9987 16.0814C14.0173 15.9156 14.0689 15.7553 14.1505 15.6098C14.232 15.4643 14.3419 15.3365 14.4736 15.2341C14.6053 15.1318 14.7561 15.0568 14.9172 15.0136C15.0784 14.9704 15.2465 14.9599 15.4118 14.9827C15.577 15.0055 15.736 15.0612 15.8794 15.1464C16.0228 15.2316 16.1477 15.3446 16.2467 15.4789C16.3458 15.6131 16.4169 15.7658 16.456 15.928C16.5324 16.245 16.482 16.5792 16.3154 16.8595C16.1489 17.1398 15.8794 17.3439 15.5644 17.4283C15.2495 17.5128 14.9141 17.4708 14.6297 17.3113C14.3452 17.1519 14.1344 16.8877 14.042 16.575ZM10.545 6.60499C10.501 6.44591 10.4889 6.27969 10.5095 6.11592C10.5301 5.95215 10.5828 5.79408 10.6648 5.65082C10.7468 5.50756 10.8563 5.38196 10.9871 5.28126C11.1179 5.18055 11.2673 5.10675 11.4267 5.06409C11.5862 5.02144 11.7525 5.01079 11.9161 5.03275C12.0797 5.05472 12.2373 5.10886 12.3799 5.19206C12.5224 5.27526 12.6471 5.38587 12.7466 5.5175C12.8462 5.64913 12.9187 5.79918 12.96 5.95899C13.0425 6.27817 12.9955 6.61701 12.8293 6.90173C12.6632 7.18645 12.3912 7.39399 12.0728 7.47918C11.7543 7.56437 11.4151 7.5203 11.1289 7.35657C10.8428 7.19285 10.6329 6.92271 10.545 6.60499Z"
                        fill="white"/>
                  </svg>
                  <p class="new-donation-modal__color-placeholder-text">{{
                      $t('create-donation.inputs.labels.color')
                    }}</p>


                </div>
                <AtSelect class="new-donation-modal__color" v-model="theme">

                  <AtOption :style="`--bg-color-option: var(--${themeOptionsEnum[themeOption]})`"
                            v-for="themeOption in themeOptions"
                            :key="themeOptionsEnum[themeOption]"
                            :value="themeOptionsEnum[themeOption]">
                  </AtOption>
                </AtSelect>
              </div>
            </div>

            <div class="new-donation-modal__donation-text-container">
              <div class="new-donation-modal__input-container">
                <div class="new-donation-modal__label-container">
                  <label for="title" class="new-donation-modal__label">{{
                      $t('create-donation.inputs.labels.title')
                    }}</label>
                  <icon-checkmark-validation class="loader" v-if="title"/>
                  <icon-error-validation class="loader" v-if="validationError.title.message"/>
                </div>
                <div class="new-donation-modal__input-container">
                  <AtInput
                      class="new-donation-modal__input"
                      id="title"
                      v-model="title"
                      :maxlength="20"
                      :placeholder="$t('create-donation.inputs.placeholders.title')"
                      size="normal"
                      @mousedown.native="clearValidationErrorTitle"
                  />
                  <span class="new-donation-modal__input-error"
                        v-if="validationError.title.message">{{ validationError.title.message }}</span>
                </div>
              </div>
              <div class="new-donation-modal__input-container">
                <label for="description"
                       class="new-donation-modal__label">{{ $t('create-donation.inputs.labels.description') }}</label>
                <AtTextarea
                    class="new-donation-modal__textarea"
                    id="description"
                    v-model="description"
                    :maxlength="255"
                    :placeholder="$t('create-donation.inputs.placeholders.description')"
                    size="normal"
                    resize="none"
                />
              </div>
            </div>

          </div>


        </template>

        <template #details>

          <div class="new-donation-modal__currency-container">

            <div class="new-donation-modal__currency-title-container">
              <div class="new-donation-modal__currency-title-label">
                <p class="new-donation-modal__currency-title">
                  {{ $t('create-donation.inputs.labels.currency_list') }}
                </p>
                <p class="new-donation-modal__currency-error"
                   v-if="currenciesModel.length < 1 && validationError.currenciesModel.message">
                  {{ validationError.currenciesModel.message }}</p>
              </div>
              <icon-checkmark-validation class="loader loader_border-success"
                                         v-if="(validationError.currenciesModel.isError !== null && !validationError.currenciesModel.isError) || currenciesModel.length > 0"/>
              <icon-error-validation class="loader loader_border-error"
                                     v-if="validationError.currenciesModel.isError !== null && validationError.currenciesModel.isError && currenciesModel.length < 1"/>
            </div>
            <div class="new-donation-modal__currency-container-info">
              <div class="new-donation-modal__currency-select-all">

                <label class="new-donation-modal__check new-donation-modal__option">
                  <input class="new-donation-modal__check-input" type="checkbox"
                         @click="toggleAllSelected"
                         :checked="isAllCurrenciesSelected"/>
                  <svg class="new-donation-modal__check-box" width="16" height="16" viewBox="0 0 16 16" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <rect class="new-donation-modal__check-square" x="0.5" y="0.5" width="15" height="15" rx="1.5"
                          stroke="#D2D4E6"/>
                    <path class="new-donation-modal__check-mark" fill-rule="evenodd" clip-rule="evenodd"
                          d="M3.13666 7.13634C3.42956 6.84344 3.90443 6.84344 4.19732 7.13634L6.66699 9.60601L11.8033 4.46967C12.0962 4.17678 12.5711 4.17678 12.864 4.46967C13.1569 4.76256 13.1569 5.23744 12.864 5.53033L7.19732 11.197C6.90443 11.4899 6.42956 11.4899 6.13666 11.197L3.13666 8.197C2.84377 7.9041 2.84377 7.42923 3.13666 7.13634Z"
                          fill="white"/>
                  </svg>

                </label>
                <p class="new-donation-modal__text-main">
                  {{ $t('create-donation.inputs.labels.currency_select_all') }}</p>

              </div>
              <div class="new-donation-modal__currency-container-count">
                <span class="new-donation-modal__currency-count-text">    {{
                    $t('create-donation.inputs.labels.currency_list_selected')
                  }}</span>
                <span class="new-donation-modal__currency-count-text">{{ selectedCurrencies }}</span>
                <span class="new-donation-modal__currency-count-text">{{
                    $t('create-donation.inputs.labels.currency_list_selected_out_of')
                  }}</span>
                <span class="new-donation-modal__currency-count-text">{{ totalCurrencies }}</span>
              </div>
            </div>

            <ul class="new-donation-modal__currency-list">
              <li class="new-donation-modal__currency-item" v-for="flatCurrency in flatCurrencies"
                  :key="flatCurrency.id + flatCurrency.network.id">
                <div class="new-donation-modal__currency-info">

                  <label class="new-donation-modal__check new-donation-modal__option">
                    <input class="new-donation-modal__check-input new-donation-modal__check-input_list"
                           type="checkbox"
                           v-model="currenciesModel"
                           :value="flatCurrency"/>
                    <svg class="new-donation-modal__check-box" width="16" height="16" viewBox="0 0 16 16" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <rect class="new-donation-modal__check-square" x="0.5" y="0.5" width="15" height="15" rx="1.5"
                            stroke="#D2D4E6"/>
                      <path class="new-donation-modal__check-mark" fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.13666 7.13634C3.42956 6.84344 3.90443 6.84344 4.19732 7.13634L6.66699 9.60601L11.8033 4.46967C12.0962 4.17678 12.5711 4.17678 12.864 4.46967C13.1569 4.76256 13.1569 5.23744 12.864 5.53033L7.19732 11.197C6.90443 11.4899 6.42956 11.4899 6.13666 11.197L3.13666 8.197C2.84377 7.9041 2.84377 7.42923 3.13666 7.13634Z"
                            fill="white"/>
                    </svg>
                    <div class="new-donation-modal__check-input-bg"/>
                  </label>
                  <div class="new-donation-modal__currency-container-title">
                    <CurrencyImg class="new-donation-modal__currency-img" :currency="flatCurrency.id"/>
                    <div class="new-donation-modal__currency-text-container">
                      <p class="new-donation-modal__currency-text-title">{{ flatCurrency.currency }}</p>
                      <p class="new-donation-modal__currency-text-subtitle">{{ flatCurrency.alias }}</p>
                    </div>
                  </div>
                </div>
                <p class="new-donation-modal__currency-text">{{ flatCurrency.network.alias }}</p>
              </li>
            </ul>


          </div>

        </template>
        <template #button>
          <AtButton :disabled="isLoading" @click="showPreview"
                    class="new-donation-modal__button">{{
              $t('create-donation.button.edit_donation')
            }}
          </AtButton>
        </template>
      </donation-pre-checkout>
      <donation-pre-checkout v-else :theme="previewData.theme">
        <template #user-info>
          <div class="new-donation-modal__donation-info">

            <div class="new-donation-modal__user-info">
              <div class="new-donation-modal__avatar">
                <img class="new-donation-modal__avatar-img" :src="previewURl" v-if="previewURl"/>
                <svg class="new-donation-modal__avatar_placeholder" v-if="!previewURl" width="106" height="106"
                     viewBox="0 0 106 106" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="53" cy="53" r="50.5" fill="#E7F0FF" stroke="white" stroke-width="5"/>
                  <path
                      d="M52.9998 51.1667C48.9497 51.1667 45.6665 47.8834 45.6665 43.8333C45.6665 39.7832 48.9497 36.5 52.9998 36.5C57.0499 36.5 60.3332 39.7832 60.3332 43.8333C60.3332 47.8834 57.0499 51.1667 52.9998 51.1667Z"
                      stroke="#0059F7" stroke-width="2" stroke-linecap="round"/>
                  <path
                      d="M38.3333 69.5V67.6667C38.3333 61.5915 43.2581 56.6667 49.3333 56.6667H56.6666C62.7417 56.6667 67.6666 61.5915 67.6666 67.6667V69.5"
                      stroke="#0059F7" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="new-donation-modal__text-container">
                <p
                    class="new-donation-modal__user-info-text new-donation-modal__user-info-text_url"
                >{{ `${location}${previewData.url}` }}</p>

              </div>
            </div>


            <div class="new-donation-modal__donation-text-container">
              <div class="new-donation-modal__input-container">
                <p class="new-donation-modal__description-title">{{ previewData.title }}</p>
              </div>
              <div class="new-donation-modal__input-container">
                <p class="new-donation-modal__description-subtitle">{{ previewData.description }}</p>
              </div>
            </div>

          </div>
        </template>
        <template #details>
          <div class="new-donation-modal__currency-container">

            <p class="new-donation-modal__currency-title">
              {{ $t('create-donation.inputs.labels.currency_list') }}
            </p>
            <div class="new-donation-modal__currency-container-info">
              <div class="new-donation-modal__currency-select-all">


              </div>
              <div class="new-donation-modal__currency-container-count">
                <span class="new-donation-modal__currency-count-text">{{
                    $t('create-donation.inputs.labels.currency_list_selected')
                  }}</span>
                <span class="new-donation-modal__currency-count-text">{{ selectedCurrencies }}</span>
                <span class="new-donation-modal__currency-count-text">{{
                    $t('create-donation.inputs.labels.currency_list_selected_out_of')
                  }}</span>
                <span class="new-donation-modal__currency-count-text">{{ totalCurrencies }}</span>
              </div>
            </div>

            <ul class="new-donation-modal__currency-list">
              <li class="new-donation-modal__currency-item" v-for="flatCurrency in previewData.currencies"
                  :key="flatCurrency.id + flatCurrency.network.id">
                <div class="new-donation-modal__currency-info">
                  <div class="new-donation-modal__currency-container-title">
                    <CurrencyImg class="new-donation-modal__currency-img" :currency="flatCurrency.id"/>
                    <div class="new-donation-modal__currency-text-container">
                      <p class="new-donation-modal__currency-text-title">{{ flatCurrency.currency }}</p>
                      <p class="new-donation-modal__currency-text-subtitle">{{ flatCurrency.alias }}</p>
                    </div>
                  </div>
                </div>
                <p class="new-donation-modal__currency-text">{{ flatCurrency.network.alias }}</p>
                <div class="new-donation-modal__check-input new-donation-modal__check-input_list"
                />
              </li>
            </ul>

          </div>
        </template>
        <template #button>
          <AtButton @click="showPreview" :disabled="isLoading"
                    class="new-donation-modal__button" v-if="!previewData">
            {{ $t('create-donation.button.edit_donation') }}
          </AtButton>
          <button type="submit" form="createDonation" v-else class="new-donation-modal__button">
            {{ $t('create-donation.button.edit_donation') }}
          </button>
        </template>
      </donation-pre-checkout>
    </form>

    <div class="success" v-else-if="!isInitResultState && isSuccess">
      <div class="success__text-container">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z"
              fill="#4CAF50"/>
          <path d="M34.5996 14.6L20.9996 28.2L15.3996 22.6L12.5996 25.4L20.9996 33.8L37.3996 17.4L34.5996 14.6Z"
                fill="#CCFF90"/>
        </svg>
        <p class="success__title">{{ $t('create-donation.result.success.edited') }}</p></div>
      <AtButton @click="pushToDonations" class="success__button-redirect">
        {{ $t('create-donation.button.ok') }}
      </AtButton>
    </div>


    <div class="fail success" v-else-if="!isInitResultState && !isSuccess">
      <div class="success__text-container">
        <svg id="Layer_1"
             width="48" height="48"
             x="0px" y="0px"
             viewBox="0 0 64 64">
          <g>
            <g id="XMLID_35_">
              <g>
                <g>
                  <path fill="#F94646" d="M32,0c17.7,0,32,14.3,32,32S49.7,64,32,64S0,49.7,0,32S14.3,0,32,0z"/>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <rect x="16.4" y="30" transform="matrix(0.7071 0.7071 -0.7071 0.7071 32 -13.2548)" fill="#FFFFFF"
                        width="31.1"
                        height="4"/>
                </g>
              </g>
              <g>
                <g>
                  <rect x="30" y="16.4" transform="matrix(0.7071 0.7071 -0.7071 0.7071 32 -13.2548)" fill="#FFFFFF"
                        width="4"
                        height="31.1"/>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <p class="success__title"> {{ $t('create-donation.result.error.edited_wrong') }}</p>
        <p class="success__subtitle">{{ $t('create-donation.result.error.edited_unable') }}</p>
        <ul>
          <li v-for="showFailedRequest in showFailedRequests" :key="showFailedRequests.alias">
            <p>{{ showFailedRequest.alias }}</p>
            <span>{{ $t('create-donation.result.error.edited_code', {error: showFailedRequest.code}) }}</span>
          </li>
        </ul>
      </div>
      <AtButton @click="pushToDonations" class="success__button-redirect">
        {{ $t('create-donation.button.ok') }}
      </AtButton>
    </div>
    <UploadImageDonationModal @uploadImage="filesChange"/>
  </div>

</template>
<script>

import {PRE_CHECKOUT_THEME_ENUM} from "../../common/constants/pre-checkout-info-theme-enum";
import BaseModal from "../components/modals/BaseModal";
import {mapActions, mapGetters, mapState} from "vuex";
import _ from "lodash";
import UploadImageDonationModal from "../components/modals/donation/UploadImageDonationModal";
import CurrencyImg from "../components/elements/CurrencyImg";
import DonationsContainer from "../components/elements/donations/donations-container";
import DonationPreCheckout from "../components/elements/donations/donation-pre-checkout";
import Preloader from "/public/components/common/uiKit/spinner/index.vue";
import PreloaderDots from "../components/common/preloader-dots";
import BlueLoader from "../components/common/blue-loader";
import Checkmark from "../components/common/checkmark";
import Cross from "../components/common/cross";
import IconCheckmarkValidation from "../components/common/icon-checkmark-validation";
import IconErrorValidation from "../components/common/icon-error-validation";

export default {
    name: "EditDonation",
    title: 'create-donation.title_edit',
    data() {
        return {
            url: '',
            alias: null,
            title: null,
            description: null,
            avatarLink: null,
            changePreCheckoutURLResult: null,
            changePreCheckoutCurrenciesResult: null,
            changePreCheckoutInfoResult: null,
            changePreCheckoutAliasResult: null,
            theme: PRE_CHECKOUT_THEME_ENUM.BLUE_GRADIENT,
            previewData: null,
            avatarFile: null,
            previewURl: null,
            isLoading: false,
            isDisabled: false,
            isChanged: false,
            isInitState: true,
            currenciesModel: [],
            validationError: {
                currenciesModel: {
                    message: null,
                    isError: null,
                },
                title: {
                    message: null,
                },
                alias: {
                    message: null,
                },
            },
            result: {
                urlQuery: {code: null, alias: 'Ссылку'},
                aliasQuery: {code: null, alias: 'Название'},
                infoQuery: {code: null, alias: 'Информацию'},
                currenciesQuery: {code: null, alias: 'Список валют'},
            },
        };
    },
    components: {
        Cross,
        Checkmark,
        BlueLoader,
        PreloaderDots,
        Preloader,
        BaseModal,
        DonationsContainer,
        CurrencyImg,
        DonationPreCheckout,
        UploadImageDonationModal,
        IconCheckmarkValidation,
        IconErrorValidation,
        // HeaderLanguage: () => import('../components/general/header/components/HeaderLanguage'),
    },
    async created() {
        await Promise.all([
            this.fetchPreCheckoutPage({pageId: this.$route.params.id}),
            this.fetchPreCheckoutCurrencies({pageId: this.$route.params.id})]);
        const {
            alias, url, info: {
                theme,
                avatarLink,
                description,
                title,
            },
        } = this.page;
        this.alias = alias;
        this.url = url;
        this.theme = theme;
        this.title = title;
        this.avatarLink = avatarLink;
        this.description = description;
        this.currenciesModel = this.intersection;
        this.previewURl = avatarLink;
        this.isChanged = false;


    },
    methods: {
        ...mapActions('donations', [
            'createPreCheckoutDonation',
            'fetchPreCheckoutPages',
            'checkPreCheckoutURLQuery',
            'fetchPreCheckoutPage',
            'fetchPreCheckoutCurrencies',
            'changePreCheckoutURLQuery',
            'changePreCheckoutAliasQuery',
            'changePreCheckoutInfoQuery',
            'changePreCheckoutCurrenciesQuery',
        ]),
        ...mapActions('app', ['openModal']),
        clearValidationErrorTitle() {
            this.validationError.title.message = null;
        },
        openImageModal() {
            this.openModal({
                name: 'UploadImageDonationModal',
                payload: {
                    maxImageSize: 7 * 1024 * 1024,
                    minImageSize: 10 * 1024,
                    allowedMimes: ['image/jpeg', 'image/png', 'image/webp'],
                },
            });
        },
        filesChange(fileList) {
            const payload = new FormData();
            payload.append("file", fileList.target.files[0]);
            payload.append("Content-Type", fileList.target.files[0].type);
            const img = new File([fileList.target.files[0]], 'test.jpeg', {
                type: 'image/jpeg',
            });
            this.previewURl = URL.createObjectURL(img);
            this.avatarFile = payload;
        },
        pushToDonations() {
            this.$router.push('/donations');
        },
        showPreview() {
            if (this.alias === null) this.alias = '';
            this.validationError = {
                currenciesModel: {
                    message: null,
                    isError: null,
                },
                title: {
                    message: null,
                },
                alias: {
                    message: null,
                },
            };
            let {
                accountId,
                url,
                alias,
                title,
                description,
                avatarLink,
                theme,
                currenciesModel,
                validationError,
                titleErrorMessage,
                currenciesModelErrorMessage,
            } = this;

            const args = {
                accountId,
                url,
                alias,
                title,
                description,
                avatarLink,
                theme,
                currencies: currenciesModel,


            };

            if (this.isButtonDisabled || this.isDisabled || this.isDisabled === null) {
                validationError.title.message = titleErrorMessage;
                validationError.currenciesModel.message = currenciesModelErrorMessage;
                validationError.currenciesModel.isError = true;
                this.isChanged = true;
                this.isDisabled = true;
                return;
            }

            const button = this.$refs.backButton.$el;
            button.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

            this.previewData = args;
        },
        toggleAllSelected() {
            if (this.isAllCurrenciesSelected) {
                this.currenciesModel = [];

            } else {
                this.currenciesModel = [];
                this.currenciesModel = [...this.flatCurrencies];
            }
        },
        goBack() {
            if (this.previewData) {
                this.previewData = null;
                return;
            }
            if (window.history.length > 2)
                this.$router.go(-1);
            else this.$router.push({name: 'donations'});
        },
        createPreCheckoutPageHandler() {
            const {
                accountId,
                url,
                alias,
                title,
                description,
                avatarLink,
                theme,
            } = this;
            const tupleCurrenciesArray = this.currenciesModel.map((i) => {
                i = [i.id, i.network.id];
                return i;
            });
            const args = {
                accountId,
                url,
                alias,
                title,
                description,
                avatarLink,
                theme,
                currencies: tupleCurrenciesArray,
                avatarFile: this.avatarFile,

            };
            this.createPreCheckoutDonation(args);
        },
        async submitForm() {

            if (this.url !== this.page.url) {
                this.result.urlQuery = {
                    ...this.result.urlQuery, ...(await this.changePreCheckoutURLQuery({
                        pageId: this.page.id,
                        url: this.url,
                    })),
                };
            }
            if (this.alias !== this.page.alias) {
                this.result.aliasQuery = {
                    ...this.result.aliasQuery, ...(await this.changePreCheckoutAliasQuery({
                        pageId: this.page.id,
                        alias: this.alias,
                    })),
                };
            }
            this.result.infoQuery = {
                ...this.result.infoQuery, ...(await this.changePreCheckoutInfoQuery({
                    pageId: this.page.id,
                    title: this.title,
                    description: this.description,
                    theme: this.theme,
                    avatarFile: this.avatarFile,
                })),
            };
            const tupleCurrenciesArray = this.currenciesModel.map((i) => {
                i = [i.id, i.network.id];
                return i;
            });
            this.result.currenciesQuery = {
                ...this.result.currenciesQuery, ...(await this.changePreCheckoutCurrenciesQuery({
                    pageId: this.page.id,
                    currencies: tupleCurrenciesArray,
                })),
            };
        },
        wrapCheckURL() {
            this.isLoading = true;
            this.isChanged = true;
            this.checkURL();

        },
        checkURL: _.debounce(function () {
            if (this.page.url !== this.url) {
                this.checkPreCheckoutURLQuery({url: this.url}).then((res) => {
                    this.isLoading = false;
                    this.isDisabled = !res;
                }).catch((e) => {
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
                this.isDisabled = false;
            }
        }, 1000)
        ,
    },
    computed: {
        ...mapState('app', ['currencies', 'isInit']),
        ...mapGetters('app', [
            'sortedCurrencies',
            'isOpenModal',
        ]),
        ...mapState('donations', {
            page: state => state.page,
            pageCurrencies: state => state.pageCurrencies,
        }),
        ...mapState('accounts', {
            accounts: state => state.accounts,
        }),
        location() {
            return this.$store.state.donations.baseUrl;
        },
        titleErrorMessage() {
            const {title} = this;
            if (!title && title !== null) {
                return this.$t('create-donation.inputs.errors.title_empty');
            }
            return null;
        },
        showFailedRequests() {
            let res = Object.keys(this.result);
            res = res.reduce((acc, resultItem) => {
                if (this.result[resultItem].code !== null && this.result[resultItem].code !== 0) {
                    acc.push(this.result[resultItem]);
                }
                return acc;
            }, []);
            return res;
        },
        isInitResultState() {
            return (this.result.infoQuery.code === null && this.result.urlQuery.code === null && this.result.aliasQuery.code === null && this.result.currenciesQuery.code === null);
        },
        isSuccess() {
            const {result} = this;
            return ((result.urlQuery.code === 0 || result.urlQuery.code === null) && (result.aliasQuery.code === 0 || result.aliasQuery.code === null) && (result.infoQuery.code === 0 || result.infoQuery.code === null) && (result.currenciesQuery.code === 0 || result.currenciesQuery.code === null));
        },
        intersection() {
            if (this.pageCurrencies.length) return _.intersectionWith(this.flatCurrencies, this.pageCurrencies, ((flat, page) => (flat.id === page.currencyId && flat.network.id === page.networkId)));
        },

        isAllCurrenciesSelected() {
            if (this.currenciesModel && this.flatCurrencies) return this.currenciesModel.length === this.flatCurrencies.length;
            return false;
        },
        isButtonDisabled() {
            const {url, currenciesModel, title} = this;
            return !url || !title || (currenciesModel?.length < 1);

        },
        currenciesModelErrorMessage() {
            const {currenciesModel} = this;
            if (currenciesModel?.length < 1) return this.$t('create-donation.inputs.errors.currencies_empty');
            return null;
        },
        totalCurrencies() {
            if (this.flatCurrencies) return this.flatCurrencies.length;
            return 0;
        },
        selectedCurrencies() {
            return this.currenciesModel?.length;
        },

        themeOptionsEnum() {
            return PRE_CHECKOUT_THEME_ENUM;
        },

        accountId() {
            return this.accounts?.[0]?.accountId;
        },
        themeOptions() {
            return Object.keys(PRE_CHECKOUT_THEME_ENUM);
        },
        creating_order() {
            return this.$t('create-order-modal.creating_order');
        },
        flatCurrencies() {
            let currenciesFlat = [];
            for (const currency of this.currencies) {
                for (const currencyNetwork of currency.networks) {

                    currenciesFlat.push({
                        ...currency,
                        network: currencyNetwork,
                    });
                }
            }
            return currenciesFlat;
        },
    },


};
</script>


<style lang="scss" scoped>

.success {
  position: absolute;
  inset: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 80px;
  max-height: 366px;
  max-width: 764px;
  background: var(--white-100);
  border-radius: 12px;
  align-items: center;
  justify-content: center;

  &__text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  &__title {
    font-family: var(--font-family);
    font-size: var(--font-size-h2);
    line-height: var(--line-height);
  }

  &__button-redirect {
    min-height: 60px;
    border-radius: 12px;
    background: var(--blue-300);
    max-width: 300px;
    color: var(--white-100);
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    width: 100%;

    ::v-deep .at-btn__text {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
      color: var(--white-100);
    }
  }
}

.loader {
  max-width: 27px;
  height: 27px;
  width: 100%;

  &_border-error {
    border: 1px solid var(--red-200);
    border-radius: 50%;
  }

  &_border-success {
    border: 1px solid var(--green-200);
    border-radius: 50%;
  }

}

.new-donation-modal {
  padding-right: var(--padding-right-container);
  padding-left: var(--padding-left-container);
  padding-top: var(--padding-top-container);

  &__title {
    font-family: var(--font-family);
    font-size: var(--font-size-h2);
    line-height: var(--line-height);
    color: var(--primary-font-color);
    margin-bottom: var(--margin-container-bottom);
    font-weight: 400;
    width: 100%;
    max-width: 1125px;

    &-container {
      display: flex;
      justify-content: center;
    }
  }

  &__subtitle {
    font-family: var(--font-family);
    font-size: var(--font-size-h3);
    line-height: var(--line-height);
    color: var(--primary-font-color);
    margin-bottom: var(--margin-container-bottom);
    font-weight: 400;
    width: 100%;
    max-width: 1125px;

    &-container {
      display: flex;
      justify-content: center;
    }
  }

  &__language {
    max-width: 50px;
    align-self: flex-end;
    margin-bottom: 10px;

    ::v-deep .at-select__selection {
      background: transparent;
      color: var(--white-100) !important;
    }

    ::v-deep .at-select__arrow {
      color: var(--white-100) !important;
    }
  }


  &__avatar {
    position: relative;
    width: 106px;
    height: 106px;
    border-radius: 50%;

    &-img {
      width: 106px;
      height: 106px;
      border-radius: 50%;
      object-fit: contain;
    }

    &-text {
      font-family: var(--font-family);
      font-size: 10px;
      font-weight: 500;
      line-height: var(--line-height);
      color: var(--white-100);
      text-align: center;
    }

    &-hover {
      position: absolute;
      top: 5px;
      right: 5px;
      bottom: 5px;
      left: 5px;
      width: 96px;
      height: 96px;
      opacity: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 10px;
      border-radius: 50%;
      z-index: 2;
      cursor: pointer;

      &:hover {
        transition: all ease 0.2s;
        opacity: 1;
        background: #BABEEE;
      }


    }

    &__avatar_placeholder {
      z-index: 1;
    }


  }

  &__all {
    background: #0059F7;
    margin-bottom: 16px;
    border-radius: 6px;
    border: none;
    width: 100%;
    max-width: 125px;
    min-height: 40px;
    transition: all 0.3s ease-in;

    &:hover {
      background: var(--blue-400);
    }

    ::v-deep .at-btn {
      max-width: 125px;
    }

    ::v-deep .at-btn__icon {
      font-size: var(--font-size-text-main);
    }

    ::v-deep .at-btn__text {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
      color: var(--white-100);
    }

    ::v-deep .at-btn__icon {
      font-size: var(--font-size-text-main);
    }

  }


  &__description {
    &-title {
      font-family: var(--font-family);
      font-size: var(--font-size-h2);
      line-height: var(--line-height);
      font-weight: 500;
      color: var(--white-100);
    }

    &-subtitle {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
      color: var(--white-100);
      line-clamp: 4;
      word-break: break-all;
    }
  }

  &__button {
    min-height: 60px;
    border-radius: 12px;
    background: var(--blue-300);
    max-width: 673px;
    color: var(--white-100);
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 25px;
    border: none;
    cursor: pointer;

    ::v-deep .at-btn__text {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
    }

    &:hover {
      background: var(--blue-400);
    }

    &:disabled {
      &:hover {
        cursor: not-allowed;
        color: #D2D2D2;
        border-color: #ECECEC;
        background-color: #F7F7F7;
      }
    }

  }


  &__text {
    &-main {
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
      line-height: var(--line-height);
      color: var(--black-200);
    }
  }

  &__option {
    display: block;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  /* Check */

  &__check {
  }

  &__check-input {
    position: absolute;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &_list {
      width: calc(100% + 80px);
      height: 100%;
      top: 0;
      left: -40px;
      border-bottom: var(--border-table);
      z-index: 3;
      cursor: pointer;
    }
  }


  &__check-box {
    position: absolute;
    width: 16px;
    height: 16px;
    z-index: 2;
  }

  &__check-focus {
    fill: none;
  }

  &__check-square {
    fill: #ffffff;
  }


  /* Checked */

  &__check-input:checked + * &__check-square {
    fill: #2939EC;
    stroke: transparent;
  }

  &__check-input:checked ~ &__check-input-bg {
    background: #E7F0FF;
    width: calc(100% + 80px);
    height: 100%;
    top: 0;
    left: -40px;
    z-index: 1;
    position: absolute;
  }

  /* Focused */

  &__check-input:focus + * &__check-focus {
    fill: #7ed321;
  }

  /* Disabled */

  &__check-input:disabled + * &__check-square {
    stroke: #9b9b9b;
  }

  &__check-input:checked:disabled + * &__check-square {
    fill: #9b9b9b;
  }

  &__currency {
    &-img {
      width: 34px;
      height: 34px;
      z-index: 2;
    }

    &-error {
      font-family: var(--font-family);
      font-size: var(--font-size-text-caption);
      line-height: var(--line-height);
      color: var(--red-200);

    }

    &-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:first-of-type .new-donation-modal__check-input {
        border-top: var(--border-table);
      }
    }

    &-container {
      position: absolute;
      bottom: 120px;
      background: var(--white-100);
      padding: 20px 40px;
      height: 100%;
      max-height: 365px;
      width: 100%;
      max-width: 673px;
      border-radius: 12px;
      overflow: auto;
      box-shadow: 0px 8px 50px rgba(10, 17, 105, 0.08);

      &-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 65px;
      }

      &-title {
        display: flex;
        align-items: center;
        gap: 15px;
        z-index: 2;
      }
    }

    &-item {
      min-height: 60px;
      display: grid;
      align-content: center;
      justify-content: space-between;
      position: relative;
      grid-template-columns: 1fr 1fr;
    }

    &-info {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    &-title {
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
      line-height: var(--line-height);
      color: var(--black-200);

      &-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

      }

      &-label {
        min-height: 60px;
      }


    }

    &-select-all {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    &-text-container {
      display: flex;
      flex-direction: column;
    }

    &-text {
      z-index: 2;
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
      line-height: var(--line-height);
      color: var(--grey-300);
    }

    &-text-title {
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
      line-height: var(--line-height);
      font-weight: 500;
      z-index: 2;
    }

    &-text-subtitle {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
      color: var(--grey-300);
    }

  }


  &__donation-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__label {
    font-family: var(--font-family);
    font-size: var(--font-size-text-secondary);
    line-height: var(--line-height);
    color: var(--white-100);

    &-container {
      display: flex;
      min-height: 33px;
      justify-content: space-between;
      align-items: center;
    }
  }


  &__user-info {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 40px;
    width: 100%;

    &-text {
      font-family: var(--font-family);
      font-size: var(--font-size-h2);
      line-height: var(--line-height);
      color: var(--white-100);

      &_url {
        font-size: var(--font-size-h3);
        word-break: break-word;
      }
    }


  }

  &__input {
    &-container {
      display: grid;
      gap: 10px;
      position: relative;
    }

    &-error {
      position: absolute;
      bottom: -25px;
      right: 0;
      font-family: var(--font-family);
      font-size: var(--font-size-text-caption);
      line-height: var(--line-height);
      color: var(--white-100);
    }

    &-file {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      appearance: none;
      opacity: 0;
      cursor: pointer;
      z-index: 2;
    }

    ::v-deep .at-input__original {
      min-height: 55px;
      font-family: var(--font-family);
      font-size: var(--font-size-text-secondary);
      line-height: var(--line-height);
      color: var(--black-200);
      border-radius: 12px;
      padding: 20px;

      &::placeholder {
        font-family: var(--font-family);
        font-size: var(--font-size-text-main);
        line-height: var(--line-height);
      }
    }

  }


  &__textarea {
    ::v-deep .at-textarea__original {
      min-height: 150px;
      font-family: var(--font-family);
      font-size: var(--font-size-text-secondary);
      line-height: var(--line-height);
      color: var(--black-200);
      border-radius: 12px;
      padding: 20px;

      &::placeholder {
        font-family: var(--font-family);
        font-size: var(--font-size-text-main);
        line-height: var(--line-height);
      }

    }
  }

  &__textarea-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid var(--white-100);
  }

  &__textarea-prepend {
    padding: 0 0 10px;
    color: var(--white-100);
    font-family: var(--font-family);
    font-size: var(--font-size-h3);
  }

  &__donation-text-container {
    max-width: 672px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  &__text-container {
    display: flex;
    flex-direction: column;
    gap: 25px;
    align-self: center;
  }


  &__user-info-input {
    width: 100%;

    ::v-deep .at-input__original {

      background: transparent;
      border: none;
      color: var(--white-100);
      caret-color: var(--white-100);
      padding: 0 0 5px;
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
    }

    ::v-deep .at-input-group__prepend {
      background: transparent;
      border: none;
      padding: 0 0 5px;
      color: var(--white-100);
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
    }

    &_alias {

      ::v-deep .at-input__original {
        font-size: var(--font-size-h2);
      }
    }

    ::v-deep .at-textarea__original {

      background: transparent;
      border: none;
      color: var(--white-100);
      caret-color: var(--white-100);
      padding: 0 0 5px;
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
    }
  }


  &__url-input {
    border-bottom: 1px solid var(--white-100);

    ::v-deep .at-input__original {
      background: transparent;
      border: none;
      padding: 0 0 10px;
      color: var(--white-100);
      caret-color: var(--white-100);
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
    }

    ::v-deep .at-input-group__prepend {
      background: transparent;
      border: none;
      padding: 0 0 10px;
      color: var(--white-100);
      font-family: var(--font-family);
      font-size: var(--font-size-h3);
    }
  }

  &__container {
    position: relative;
    height: 980px;
    background: #FFFFFF;
    width: 100%;
    max-width: 1125px;
    -webkit-clip-path: url(#my-clip-path);
    clip-path: url(#my-clip-path);
  }

  &__top-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 711px;
    background: var(--bg-color);
    border-radius: 12px;
    margin: 15px;
  }

  &__color {
    max-width: 165px;

    &-placeholder {
      top: 0;
      left: 0;
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;

      &-text {
        color: var(--white-100);
        font-size: var(--font-size-text-secondary);
        line-height: var(--line-height);
        font-family: var(--font-family);
      }
    }

    &-container {
      position: relative;
      width: 100%;
      max-width: 165px;
    }


    ::v-deep .at-select__selection {
      background: transparent;
      border: 1px dashed var(--white-100);
      min-height: 96px;
    }

    ::v-deep .at-select__dropdown {
      width: calc(100% + 135px);
      top: unset !important;
      left: unset !important;
      right: 0;
      bottom: -185px;
    }

    ::v-deep .at-select__arrow {
      display: none;
    }

    ::v-deep .at-select__dropdown .at-select__list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
      padding: 10px;

      border-radius: 12px;
    }

    ::v-deep .at-select__option {
      width: 48px;
      height: 48px;
      background: var(--bg-color-option);
      color: transparent;
      border-radius: 12px;
    }

    ::v-deep .at-select__selected {
      color: transparent;
      display: none;
    }
  }


}

@media screen and (max-width: 950px) {
  .new-donation-modal {
    &__user-info {
      display: grid;
      grid-template-areas: 'avatar text'
                           'color color';
      max-width: 100%;
      justify-content: center;
      gap: 10px;

      &-input {
        font-size: var(--font-size-text-main);

        ::v-deep .at-textarea__original {
          padding: 0;
          font-size: var(--font-size-text-main);
        }

        &_alias {
          ::v-deep .at-input__original {
            font-size: var(--font-size-h3);
            font-weight: 600;
            padding: 0;
          }
        }
      }


    }

    &__textarea-prepend {
      padding: 0;
      font-size: var(--font-size-text-main);
    }

    &__text-container {
      gap: 10px;
    }

    &__color-container {
      grid-area: color;
      max-width: 100%;
    }

    &__color {
      max-width: 100%;

      ::v-deep .at-select__dropdown {
        width: 100%;
      }

      ::v-deep .at-select__dropdown .at-select__list {
        justify-items: center;
      }

      ::v-deep .at-select__selection {
        min-height: 50px;
      }
    }

    &__avatar {
      position: relative;
      height: 57px;
      width: 57px;


      &-hover {
        width: 57px;
        height: 57px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        gap: 5px;
      }

      &-text {
        display: none;
      }

      &-img {
        height: 57px;
        width: 57px;
      }

      &_placeholder {
        height: 57px;
        width: 57px;
      }
    }

    &__textarea {
      ::v-deep .at-textarea__original {
        min-height: 115px;
      }
    }

    &__input {
      &-container {
        gap: 5px
      }

      ::v-deep.at-input__original {
        height: 40px;
      }
    }


  }
}

@media screen and (max-width: 1180px) {
  .loader {
    height: 24px;
    padding: 2px;
    max-width: 24px;
  }

}

@media screen and (max-width: 768px) {
  .new-donation-modal {
    padding-left: 10px;
    padding-right: 10px;

    &__check-input:checked ~ &__check-input-bg {
      background: #E7F0FF;
      width: calc(100% + 20px);
      height: 100%;
      top: 0;
      left: -10px;
      z-index: 1;
      position: absolute;
    }

    &__input {
      ::v-deep .at-input__original {
        padding: 15px;
      }
    }


    &__text-main {
      font-size: var(--font-size-text-main);
    }

    &__currency-count-text {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
    }

    &__currency-select-all {
      gap: 5px;
    }

    &__currency-container {
      max-width: calc(100% - 40px);
      max-height: 300px;
      padding: 10px 10px 0 10px;
    }

    &__check-input {
      &_list {
        width: calc(100% + 20px);
        height: 100%;
        top: 0;
        left: -10px;
      }
    }

    &__currency-text {
      font-size: var(--font-size-text-main);
      justify-self: flex-end;
      text-align: end;
    }

    &__currency-img {
      width: 26px;
      height: 26px;
    }
  }
}


@media screen and (max-width: 500px) {
  .new-donation-modal {
    &__textarea-prepend {
      display: none;
    }

    &__color {
      ::v-deep .at-select__dropdown {
        bottom: -156px;
      }

      ::v-deep .at-select__dropdown .at-select__list {
        justify-items: center;
      }

      ::v-deep .at-select__option {
        width: 35px;
        height: 35px;
        border-radius: 10px;
      }
    }

  }
}

</style>



